export default __webpack_public_path__ + "static/media/digibanklogo.c31125be.png";